import React from 'react';
import './index.css';
import Toast from '../common/Toast'
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
const title = "来“鼠”钱，好运到！"
const rechargeConfig = [
    {
        value:28,
        style:{
            position:"absolute",
            top:"6.9rem",
            left:"0.3rem",
            width:"6.9rem",
            height:"1.65rem",
        }
    },
    {
        value:58,
        style:{
            position:"absolute",
            top:"9rem",
            left:"0.3rem",
            width:"6.9rem",
            height:"1.65rem",
        }
    }
]
const rechargeType = "springfestival" //todo:

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weixinurl: "",
            bookId: "",
            hongbao:'',
            coin:'',
            text:''
        };
    }

    setHeight = () => {
        let height = document.documentElement.clientHeight || window.innerHeight
        let recharge = document.getElementById("recharge")
        recharge.style.height = height+"px"
    }

    componentDidMount() {
        console.log('地址',);
        this.setHeight()
        this.fromPositionCount();
        document.title = title
        this.setState({
            bookId: this.props.match.params.bookId,
            weixinurl: this.props.match.params.weixinurl
        },()=>{
            this.getUserInfo()
        })
    }
    positionCount = (id) => {
        // position_id:
        // 1,元旦活动_首页banner入口
        // 2,元旦活动_充值页banner入口
        // 3,元旦活动-阅读历史页banner入口
        // 4,元旦活动_前端活动页面
        // 5,元旦活动_前端页面点击投入金币的点击数
        util.ajax({
            url: "/zh/positioncount/push",
            isUser: true,
            isWechatId: true,
            data:{
                position_id:id,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    console.log("打点",id,"成功")
                }
            }
        });
    }
    fromPositionCount = () => {
        //来源打点 以及进入打点
        let from = commonTools.searchPar().from
        if(from === '1'){
            from = 8;
        }
        if(from === '2'){
            from = 9;
        }
        if(from === '3'){
            from = 10;
        }
        if(from){
            this.positionCount(from)
        }
        this.positionCount(6)
    }
    getUserInfo(){
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        coin:data.user_money.coin,
                        hongbao:data.user_money.hongbao
                    })
                }
            }
        });
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }

    recharge(item,index){
        this.positionCount(7);
        if(!item){return false;}
        let url = this.state.weixinurl || `${document.location.href}`
        let params = {
            'total_fee':item*100,
            'back_url':url,
            'error_url':url,
            [rechargeType]: 1
        }
        if(!!this.state.bookId){
            params.book_id = this.state.bookId
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                }else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    goRoute(){
        this.props.history.push('/balance')
    }

    render() {
        return (
            <div className='newyearrecharge' style={{background:"#003f6a"}}>
                <div className='recharge' id="recharge" style={{overflow:"inherit"}}>
                    <div className='recharge_items'>
                        <img style={{width:"100%"}} src={require("../../../common/images/chunjie.jpg")} />
                        {(rechargeConfig || []).map((item,index)=>{
                            let value = item.value
                            return (
                                <div style={item.style} onClick={()=>this.recharge(value,index)} key={`r${index}`}></div>
                            )
                        })}
                    </div>
                </div>
                <Toast text={this.state.text}/>
            </div>
        );
    }
}